module.exports = __webpack_public_path__ + "img/eppingforest.3b373b6a.jpg";